import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthService } from '../../services/auth.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';

enum State {
  login,
  forgottenPassword,
  resetPassword
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginModel: LoginModel = new LoginModel();
  loginMessage = '';

  showForgottenPassword = false;
  showReset = false;
  code;
  userId;

  currentState = State.login;

  //isLoading: boolean = false;
  invalid: boolean = false;

  loginForm = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    rememberMe: new FormControl(false),
  })

  resetForm = new FormGroup({
    token: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    confirmPassword: new FormControl('', Validators.required)
  });



  constructor(private authService: AuthService, private http: HttpClient, private auth: AuthService, private router: Router, private route: ActivatedRoute) {

  }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      if (token != undefined) {
        this.currentState = State.resetPassword;
        this.showForgottenPassword = false;
        this.showReset = true;
        this.resetForm.patchValue({ 'token': token });
      }
    });

  }

  //login() {
  //  this.http.post('/api/account/login', this.loginModel).subscribe(data => {
  //    this.auth.setUser(data);
  //    this.router.navigate(['/dashboard']);
  //  }, error => {
  //    this.loginMessage = 'Invalid email or password';
  //  });
  //}

  toggleForgottenPassword() {
    this.loginMessage = '';
    this.showForgottenPassword = !this.showForgottenPassword;
  }

  resetPassword() {
    this.authService.reset(this.loginModel.Email).then((data) => {
      console.log(data);
    });
  }

  confirmResetPassword() {
    if (this.loginModel.Password == '' || this.loginModel.Password == null) {
      this.loginMessage = 'Please enter password';
      return;
    }

    if (this.loginModel.Password != this.loginModel.Password2) {
      this.loginMessage = 'Passwords do not match';
      return;
    }

    this.authService.resetPassword(this.resetForm.controls['token'].value, this.loginModel.Password).then((data) => {

      if (data) {
        this.showLogin();
      }

    });
  }

  showLogin() {
    this.showForgottenPassword = false;
    this.showReset = false;
  }


  async submit() {
    console.log("submit");
    this.invalid = false;
    console.log(this.loginModel);

    var loginDto = await this.authService.login(this.loginModel.Email, this.loginModel.Password, false);


    if (loginDto == null) {
      this.invalid = true;
      this.loginMessage = `Your login attempt was not successful. Please try again.`;
    }

    this.router.navigate(['/home/net_holdings']);
  }

}

export class LoginModel {
  Id: string;
  Email: string;
  Password: string;
  Password2: string;
  Code: string;
}
